import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Card, CardHeader, CardContent, IconButton, Tooltip, Button } from "@mui/material";

import { Link } from "react-router-dom";

import { BasicFlex, LabelUpper } from "../../../utils/Common";

import { capitalize } from "lodash";


// customer info icons
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import SubdirectoryArrowRightRoundedIcon from '@mui/icons-material/SubdirectoryArrowRightRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';

// invoice info icons
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';

/// actions icons
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import AttachEmailRoundedIcon from '@mui/icons-material/AttachEmailRounded';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';


import { formatGenericDate, formatCurrency, formatPhoneNumber, displayTruncated } from "../../../utils/util";

// download button
import ShareButton from "../../../utils/utilities/Buttons/ShareButton";
import DownloadButton from "../../../utils/utilities/Buttons/DownloadButton";

import SimpleChip from "../../../utils/utilities/SimpleChip";

const BillContainer = styled(BasicFlex)`
  border: 2px dotted ${props => props.theme.colors.border};
  flex-direction: column;
  padding: 2rem;
  border-radius: 5px;
  background-color: white;
`;

const ActionBar = styled(BasicFlex)`
  justify-content: flex-end;
  gap: 1rem;
`;

const InfoBar = styled(BasicFlex)`

`

const InfoLabel = styled.div`
  font-weight: 500;
  text-transform: uppercase;
  color: ${props => props.theme.colors.mildText};
  margin-bottom: 1rem;
`

const VendorInfo = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;
`;

const VendorInfoLines = styled(BasicFlex)`
  justify-content: flex-start;
  gap: .8rem;
  margin: .4rem 0;
  /* font-weight: 500; */
  font-style: italic;
  line-height: ${props => props.$multiline ? '2.2rem' : 'normal'};
`;

const DateInfo = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;

`;

const DateInfoLines = styled(BasicFlex)`
  justify-content: flex-start;
  gap: .8rem;
  margin: .6rem 0;
  /* font-weight: 500; */

  .header {
    font-weight: 500;
  }

  .info {

  }
`;

const LineItemsContainer = styled.div`
  margin-top: 5rem;
  width: 100%;

  @media ${props => props.theme.breaks.down('lg')} {
    overflow-x: scroll;
    width: 100%;
  }
`;

const LineItemsSection = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;

  @media ${props => props.theme.breaks.down('lg')} {
    min-width: max-content;
  }
`;

/* main bill display */
  const HeaderLines = styled(BasicFlex)`
    justify-content: space-between;
    border-top: 2px solid ${props => props.theme.colors.darkBg};
    border-bottom: 2px solid ${props => props.theme.colors.darkBg};
  `;

  const HeaderItem = styled.div`
    background-color: ${props => props.theme.colors.darkBg};
    padding: 1rem 2rem;
    margin: .2rem 0;
    font-weight: 500;
    flex-basis: 0;
    flex-grow: 1;
    text-align: ${props => props.align || "center"};
  `

  const RepairLabel = styled(LabelUpper)`
    margin: .3rem 0;
  `

  const LineItemRow = styled(BasicFlex)`
    border-bottom: 1px solid ${props => props.theme.colors.border};
    justify-content: space-between;
    margin-top: .8rem;
    
    ${props => props.$noBorder ? css/* closed */`
    border: none;
    ` : ''}
  `

  const SubLineItemRow = styled(LineItemRow)`
    color: ${props => props.theme.colors.mildText};
    font-style: italic;
    font-weight: 500;
    margin-top: .1rem;
    border: none;

    ${props => props.$last ? css/* closed */`
      border-bottom: 1px solid ${props.theme.colors.border} !important;
      padding-bottom: .4rem;
    ` : ''}
  `

  const LineItem = styled.div`
    flex-basis: 0;
    flex-grow: 1;
    padding: .8rem 2rem;
    text-align: ${props => props.align || "center"};
  `

  const SubLine = styled.div`
    padding: .4rem 1rem;
    font-weight: normal;
  `
/* end main bill display */

const SummarySection = styled(BasicFlex)`
  background-color: ${props => props.theme.colors.darkBg};
  margin-top: 1rem;
  border-radius: 5px;
  padding: 2rem 4rem;
  text-transform: uppercase;
  font-weight: 500;

  .amount {
    width: 10rem;
    text-align: right;
  }
`;

const OriginalAmount = styled.span`
  text-decoration: line-through;
  color: ${props => props.theme.colors.lightText};
`

const SoldInfo = styled.span`
  font-weight: 500;
`

const BillDisplay = ({bill = {}}) => {

  console.log(bill);

  let vendor = bill?.vendor || {}

  let line_items = bill?.line_items || [];

  let wigs = bill?.wigs || [];

  // line_items = line_items.filter(li => {
  //   let returned = ["inventory"];
  //   if (returned.includes(li.item_type)) return true;
  //   if (li.item_type === "repair") {
  //     let findWig = line_items.find(wig => wig.item_type === "inventory" && wig.name === li.wig_id);
  //     if (findWig) return false;
  //     return true;
  //   }
  //   return false;
  // })

  return (
    <BillContainer>
      <ActionBar>
       {/* <ShareButton apiUrl={`/bills/generate/${bill.bill_id}`} />
       <DownloadButton url={`/bills/generate/${bill.bill_id}`} />
       <Tooltip title="Attach PDF To Email"><IconButton size="small" color="secondary"><AttachEmailRoundedIcon /></IconButton></Tooltip> */}
       <Link to={`/vendor_payments/edit`} state={{vendor_id: vendor.vendor_id, vendor_name: vendor.full_name, bill_id: bill.bill_id}}>
        <Button startIcon={<PaymentsRoundedIcon />} size="small" variant="contained" color="primary">Pay Now</Button>
       </Link>
      </ActionBar>
      <InfoBar>
        <VendorInfo>
          <InfoLabel>Billed By</InfoLabel>
          <VendorInfoLines><AccountBoxRoundedIcon color="basic" fontSize="small" />{vendor.full_name}</VendorInfoLines>
          <VendorInfoLines align="flex-start" $multiline><PlaceRoundedIcon color="basic" fontSize="small" />{vendor.address} <br/>{vendor.city ? `${vendor.city}, ` : ''} {vendor.state ? `${vendor.state}, ` : ''} {vendor.zip}</VendorInfoLines>
          <VendorInfoLines><PhoneOutlinedIcon color="basic" fontSize="small" />{formatPhoneNumber(vendor.mobile_phone)}</VendorInfoLines>
          <VendorInfoLines><EmailOutlinedIcon color="basic" fontSize="small" />{vendor.email}</VendorInfoLines>
          </VendorInfo>
        <DateInfo>
          {/* <InfoLabel>Invoice Info</InfoLabel> */}
          <DateInfoLines><ReceiptRoundedIcon color="basic" fontSize="small" /> <span className="header">Bill #:</span> <span className="info">{bill.bill_num}</span></DateInfoLines>
          <DateInfoLines><CalendarMonthRoundedIcon color="basic" fontSize="small" /> <span className="header">Date:</span> <span className="info">{formatGenericDate(bill.date)}</span></DateInfoLines>
          <DateInfoLines><PendingActionsRoundedIcon color="basic" fontSize="small" /> <span className="header">Due Date:</span> <span className="info">{formatGenericDate(bill.due_date)}</span></DateInfoLines>
        </DateInfo>
      </InfoBar>

      <LineItemsContainer>
        <LineItemsSection>
          <HeaderLines>
            <HeaderItem align="left">Name</HeaderItem>
            <HeaderItem align="left">Item Type</HeaderItem>
            <HeaderItem align="left">Description</HeaderItem>
            <HeaderItem align="right">Qty</HeaderItem>
            <HeaderItem align="right">Cost</HeaderItem>
            <HeaderItem align="right">Balance</HeaderItem>
            <HeaderItem align="right">Total</HeaderItem>
          </HeaderLines>
          
          {wigs?.map((item, index) => {
            return (
            <>
              <LineItemRow key={item.name}>
                <LineItem align="left">
                  <BasicFlex dir="column" gap=".4rem">
                    <div>{item.name}</div>
                    <SimpleChip label={displayTruncated(item.wig_sku, {length: 25})} size="small" />
                  </BasicFlex>
                </LineItem>
                <LineItem align="left">{capitalize(item.item_type)}</LineItem>
                <LineItem align="left">
                  <BasicFlex dir="column" gap=".4rem">
                  <BasicFlex><span>Sold To:</span>  <SoldInfo>{item.customer_name}</SoldInfo></BasicFlex>
                  <BasicFlex><span>Date:</span> <SoldInfo>{formatGenericDate(item.sold_date, "short")}</SoldInfo></BasicFlex>
                  </BasicFlex>
                </LineItem>
                <LineItem align="right">1</LineItem>
                <LineItem align="right">{formatCurrency(item.cost)}</LineItem>
                <LineItem align="right">{formatCurrency(item.balance_due)}</LineItem>
                <LineItem align="right">
                  <BasicFlex justify="flex-end" gap="1rem">
                    {item.cost !== item.total_cost ? <OriginalAmount>{formatCurrency(item.cost)}</OriginalAmount> : null}
                    <div>{formatCurrency(item.total_cost)}</div>
                  </BasicFlex>
                </LineItem>
              </LineItemRow>
            </>
          )}
          )}
          {line_items?.map((item, index) => {
            let rate = item.item_type === "discount" ? -item.rate : item.rate;
            rate = item.rate_type === "fixed" ? formatCurrency(rate) : `${rate}%`;
            let calculated = item.item_type === "discount" ? -item.calculated_amount : item.calculated_amount;
            return (
            <>
              <LineItemRow key={item.name}>
                <LineItem align="left">{item.name}</LineItem>
                <LineItem align="left">{capitalize(item.item_type)}</LineItem>
                <LineItem align="left">{displayTruncated(item.description, {length: 15})}</LineItem>
                <LineItem align="right">{item.quantity}</LineItem>
                <LineItem align="right">{rate}</LineItem>
                <LineItem align="right">-</LineItem>
                <LineItem align="right">{formatCurrency(calculated)}</LineItem>
              </LineItemRow>
            </>
          )}
          )}

        </LineItemsSection>
      </LineItemsContainer>


      <SummarySection dir="column" gap="1.6rem">
        <BasicFlex justify="flex-end" gap="2rem"><div>Subtotal:</div><div className="amount">{formatCurrency(bill.subtotal)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Tax:</div><div className="amount">{formatCurrency(bill.tax)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Total:</div><div className="amount">{formatCurrency(bill.total)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Amount Paid:</div><div className="amount">{formatCurrency(bill.total_paid)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Balance:</div><div className="amount">{formatCurrency(bill.balance)}</div></BasicFlex>
      </SummarySection>
    </BillContainer>
  )

};

export default BillDisplay;